"use client";

import { OTDCard, useActions, type UIAction } from "@huub-web/ui";
import type { FC, Ref } from "react";

export type OTDCardTemplateProps = {
  id: string;
  title: string;
  description: string;
  buttonValue: string;
  action: UIAction;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

export const OTDCardTemplate: FC<OTDCardTemplateProps> = ({
  id,
  title,
  description,
  buttonValue,
  action,
  ref,
}) => {
  const { handleAction } = useActions();

  const handleClick = () => {
    if (action) {
      handleAction(action);
    }
  };

  return (
    <OTDCard
      ref={ref}
      id={id}
      title={title}
      description={description}
      buttonValue={buttonValue}
      label={title}
      onClick={handleClick}
    />
  );
};
